import Vue from 'vue'
import Vuex from 'vuex'
import AuthenticationStore from './authentication/index'
import OT from './OT'
import EquipmentStore from './EquipmentStore'
import ClientStore from './OTClient'
import OTStore from './OTStore'
import TechniciansStore from './TechniciansStore'
import Diagnosticos from './OTDiagnose'
import Warehouse from './Warehouse'
import Notifications from './Notifications'
import Exceptions from './Exceptions'
import PreIngreso from './PreIngreso'
import Quotations from './Quotations'
import PartsStore from './PartsStore'
import OVStore from './OVStore'
import Campaign from './Campaign'
import InstantCampaign from './InstantCampaign'
import VentaCenterStore from './VentaCenterStore'
import TipoDispositivoStore from './TipoDispositivoStore'
import OVEStore from './OVEStore'
import OVGStore from './OVGStore'
import OVGCenterStore from './OVGCenterStore'
import PedidosTiendaStore from './PedidosTiendaStore'
import PedidosRepuestosStore from './PedidosRepuestosStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    AuthenticationStore,
    OTStore,
    OT,
    EquipmentStore,
    ClientStore,
    TechniciansStore,
    Diagnosticos,
    Warehouse,
    Notifications,
    Exceptions,
    PreIngreso,
    Quotations,
    PartsStore,
    OVStore,
    Campaign,
    InstantCampaign,
    VentaCenterStore,
    TipoDispositivoStore,
    OVEStore,
    OVGStore,
    OVGCenterStore,
    PedidosTiendaStore,
    PedidosRepuestosStore,
  },
})
